export default class Helper {

    static isFileLink(el){
        return el.href ? el.href.match(/\.doc(x?)$|\.xls(x?)$|\.exe$|\.ppt(x?)$\.zip$|\.pdf$|\.mp3$|\.psd$/i,) : false;
    }

    static isExternalLink(el){
        return el.href && el.hostname ? document.location.hostname !== el.hostname : false;
    }

    static linkExtension(el) {
        const path = el.href;
        return path.substr(path.lastIndexOf(".") + 1, path.length );
    }
}